// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlighted-message {
  background-color: rgba(255, 193, 7, 0.3) !important;
  transition: background-color 0.3s ease;
  border-left: 4px solid #ffc107 !important;
  animation: highlightPulse 2s ease-in-out;
}

@keyframes highlightPulse {
  0% {
    background-color: rgba(255, 193, 7, 0.6);
  }
  50% {
    background-color: rgba(255, 193, 7, 0.3);
  }
  100% {
    background-color: rgba(255, 193, 7, 0.3);
  }
}

.search-highlight {
  background-color: #ffeb3b;
  padding: 2px 4px;
  border-radius: 3px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/MessageSearch/MessageSearch.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;EACnD,sCAAsC;EACtC,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".highlighted-message {\n  background-color: rgba(255, 193, 7, 0.3) !important;\n  transition: background-color 0.3s ease;\n  border-left: 4px solid #ffc107 !important;\n  animation: highlightPulse 2s ease-in-out;\n}\n\n@keyframes highlightPulse {\n  0% {\n    background-color: rgba(255, 193, 7, 0.6);\n  }\n  50% {\n    background-color: rgba(255, 193, 7, 0.3);\n  }\n  100% {\n    background-color: rgba(255, 193, 7, 0.3);\n  }\n}\n\n.search-highlight {\n  background-color: #ffeb3b;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
